import { useCallback, useEffect } from 'react'
import { LoginForm, Login as RALogin, useNotify } from 'react-admin'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'
import Storage from '../../../lib/Storage'
import Logo from '@/icons/logo.svg?react'
import CONSTANTS from '@/constants'
import { Box, Link as MuiLink } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

const Login = () => {
  const { setRecaptchaToken } = Storage()
  const notify = useNotify()

  useEffect(() => {
    const flash = sessionStorage.getItem('flash_success')
    if (flash) {
      sessionStorage.removeItem('flash_success')
      notify(flash, { type: 'success' })
    }
  }, [notify])

  const onVerify = useCallback(
    (token: string) => {
      setRecaptchaToken(token)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CONSTANTS.RECAPTCHA_V3_SITE_KEY}>
      <GoogleReCaptcha onVerify={onVerify} refreshReCaptcha />
      <RALogin
        avatarIcon={<Logo />}
        sx={{
          backgroundImage: 'none',
          '& .MuiAvatar-root': {
            borderRadius: 0,
            width: '200px',
            backgroundColor: 'inherit',
            color: 'primary.main'
          }
        }}
      >
        <LoginForm />
        <Box textAlign="center" mt={2} pb={2}>
          <MuiLink
            component={RouterLink}
            to="/forgot-password"
            underline="hover"
            sx={{ fontSize: '0.85rem' }}
          >
            Forgot Password?
          </MuiLink>
        </Box>
      </RALogin>
    </GoogleReCaptchaProvider>
  )
}

export default Login
